// extracted by mini-css-extract-plugin
export default {"bodyFooter":"Footer_bodyFooter__bPI+E","icons":"Footer_icons__PEncG","copyright":"Footer_copyright__MSy5Y"};